

export default {
  name: 'SearchAddress',
  components: {
  },
  layout: '',
  props: {
    purchaseValue: { // 01: 택배배송, 02: 매장픽업, 03:정기배송, 04: 대량배송
      type: String,
      default: '01'
    },
    reOpen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isScriptLoaded: false,
      addrInfo: {
        addrZip: '',
        addrBassEaddr: '',
        strMngNo: '',
        strNknmNm: '',
      }
    }
  },
  head () {
    return {
      script: [
        {
          title: '다이소몰 : 오늘배송 주소 찾기',
          src: '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js',
          callback: () => { this.isScriptLoaded = true }
        },
        { src: '//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=c76ff8c45babd7968ccb5e957bb260e6&libraries=services' }
      ]
    }
  },
  watch: {
    isScriptLoaded (value) {
      if (value) {
        this.addrSearch()
      }
    },
    reOpen (value) {
      if (value) {
        this.addrSearch()
      }
    }
  },
  methods: {
    addrSearch (flag) { // 우편번호찾기
      const postLayer = this.$refs.postLayer

      if (postLayer) {
        // this.$nuxt.$loading.finish()
        postLayer.style.height = (screen.height - 200) + 'px'
        this.loadDaumPost(postLayer)
      }
    },
    loadDaumPost (container) {
      // eslint-disable-next-line no-undef
      new daum.Postcode({
        oncomplete: (data) => {
          console.log('loadDaumPost', data)
          // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

          // 도로명 주소의 노출 규칙에 따라 주소를 표시한다.
          // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
          let rnBassAddr = data.roadAddress || data.autoRoadAddress // 도로명기본주소
          // let lnmBassAddr = data.jibunAddress || data.autoJibunAddress // 지번기본주소

          // 건물명이 있는경우 빌딩주소를 도로명 주소에 추가 한다.
          if (data.buildingName !== '') {
            rnBassAddr += ' (' + data.buildingName + ')'
            // lnmBassAddr += ' (' + data.buildingName + ')'
          }
          this.addrInfo.addrZip = data.zonecode // 우편번호
          this.addrInfo.addrBassEaddr = rnBassAddr // 도로명기본주소
          this.$emit('next', 1, this.addrInfo)
          container.style.display = 'none'
        },
        width: '100%',
        height: '100%',
        maxSuggestItems: 5
      }).embed(container)

      // iframe을 넣은 element를 보이게 한다.
      container.style.display = 'block'
    },
  }
}
